import http_request from './http_request'
import config from 'config'
import fileAppendToForm from 'helpers/fileAppendToForm'
import agentTypes from 'helpers/enums/agentTypes'

function upload(file, gameUid, activityUid, answerUid) {
	const formData = getFileFormData(file)
	return http_request.post(config.slides + `slide/game/${gameUid}/activity/${activityUid}/answer/${answerUid}/asset`)
		.withExternalJwt()
		.type('')
		.send(formData)
}

function uploadQuestionImage(file, gameUid, questionUid) {
	const formData = getFileFormData(file)
	return http_request.post(config.slides + `slide/game/${gameUid}/question/${questionUid}/asset`)
		.withExternalJwt()
		.type('')
		.send(formData)
}

function initializeVideo(videoVersions, size) {
	return http_request
		.post(`${config.slide_api_gateway}assets/video/initialize`)
		.type('')
		.withExternalJwt()
		.send({ videoVersions, size })
}

function initializeImage(imageVersions) {
	return http_request
		.post(`${config.slide_api_gateway}assets/image/initialize`)
		.type('')
		.withExternalJwt()
		.send({ imageVersions })
}

function initializeBinary(binaryName) {
	return http_request
		.post(`${config.slide_api_gateway}assets/binary/initialize`)
		.withExternalJwt()
		.send({ sourceId: binaryName })
}

function uploadVideo(file, assetUid, assetPosterUid, microtime, progressCallback, externalUid) {
	let formData = new FormData()
	formData = fileAppendToForm(formData, file)
	formData.append('assetUid', assetUid)
	formData.append('assetPosterUid', assetPosterUid)
	formData.append('microtime', microtime)
	formData.append('externalUid', externalUid)
	return http_request
		.post(`${config.api}interactive_video/upload`)
		.progress(progressCallback)
		.type('')
		.send(formData)
}

function uploadPoster(file, assetUid) {
	const formData = getFileFormData(file)
	formData.append('assetUid', assetUid)
	return http_request
		.post(`${config.api}interactive_video/upload/poster`)
		.type('')
		.send(formData)
}

function uploadBinary(file, assetUid, fileName) {
	const formData = getFileFormData(file)
	formData.append('assetUid', assetUid)
	formData.append('assetName', fileName)
	return http_request
		.post(`${config.api}interactive_video/upload/handout`)
		.type('')
		.send(formData)
}

function getVideoStatus(assetUid) {
	return http_request
		.get(`${config.slide_api_gateway}assets/${assetUid}/status`)
		.withExternalJwt()
		.send()
}

function getFileFormData(file) {
	const formData = new FormData()
	formData.append('type', file.type)
	formData.append('name', file.name)
	formData.append('size', file.size)
	formData.append('link', file.link)
	if (file.token) {
		formData.append('token', file.token)
	}
	if (file.file && file.file.length > 0) {
		formData.append('file', file.file[0])
	}
	return formData
}

function createExternalVideo(source, sourceId, duration, title) {
	return http_request
		.post(`${config.slide_api_gateway}assets/video/external/create`)
		.type('')
		.withExternalJwt()
		.send({
			source,
			sourceId,
			duration,
			title,
		})
}

function createExternalImage(source, sourceId) {
	return http_request
		.post(`${config.slide_api_gateway}assets/image/external/create`)
		.type('')
		.withExternalJwt()
		.send({
			source,
			sourceId,
		})
}

function getBinary(uid, jwt) {
	return http_request
		.get(`${config.slide_api_gateway}assets/binary/${uid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

export default {
	upload,
	uploadQuestionImage,
	uploadVideo,
	uploadPoster,
	uploadBinary,
	getVideoStatus,
	initializeVideo,
	initializeImage,
	initializeBinary,
	createExternalVideo,
	createExternalImage,
	getBinary,
}
